import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import SuccessModal from "../../components/common/SuccessModal";
import { FaEye, FaPlus, FaTrash } from "react-icons/fa";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { AddUpdateDivisionalCategory } from "../../services/Divisional Category/DivisionalCategoryApi";
import { GetChangeTenderStatus } from "../../services/Client/ClientApi";
import { UploadImageWithNodeApi } from "../../services/Media/UploadMedia";
import DatePicker from 'react-date-picker';
import 'react-calendar/dist/Calendar.css';
import 'react-date-picker/dist/DatePicker.css';

const TenderStatusDialog = ({ open, onClose, tender, userKeyID, onSubmit }) => {

    const { setLoader } = useContext(LoaderContext);
    const minDate = new Date(1950, 0, 1);
    const today = new Date();
    const [requireErrorMessage1, setRequireErrorMessage1] = useState(false);
    const [requireErrorMessage2, setRequireErrorMessage2] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);
    const [tenderDocumentModel, setLostDocuments] = useState([
        {
            documentTitle: "",
            documentURL: "",
        },
    ]);
    const [formData, setFormData] = useState({
        tenderStatusID: null,
        remark: "",
        projectKeyID: null,
        securityDeposit: null,
        securityDepositAttachment: null,
        performanceSecurityDeposit: null,
        performanceSecurityDepositAttachment: null,
        bankGuarantee: null,
        startDate: null,
        endDate: null,
        agreementStampDuty: null,
        agreementAttachment: null,
        errors: {}
    })
    const statusOptions = [
        { label: "In-Progress", value: 1 },
        { label: "Win", value: 2 },
        { label: "Lost", value: 3 },
    ];

    // useEffect(() => {
    //     setLostDocuments([]);
    //     setRequireErrorMessage1(false)
    //     setRequireErrorMessage2(false)
    //     if (open && tender) {
    //         const selectedStatus = statusOptions.find(
    //             (x) => x.value === tender?.tenderStatusID
    //         );
    //         setFormData({
    //             tenderStatusID: selectedStatus || null,
    //             remark: tender?.tenderStatusRemark ?? "",
    //             securityDeposit: tender?.securityDeposit ?? null,
    //             securityDepositAttachment: tender?.securityDepositAttachment ?? null,
    //             performanceSecurityDeposit:
    //                 tender?.performanceSecurityDeposit ?? null,
    //             performanceSecurityDepositAttachment:
    //                 tender?.performanceSecurityDepositAttachment ?? null,
    //             bankGuarantee: tender?.bankGuarantee ?? null,
    //             startDate: tender?.startDate ?? null,
    //             endDate: tender?.endDate ?? null,
    //             agreementStampDuty: tender?.agreementStampDuty ?? null,
    //             agreementAttachment: tender?.agreementAttachment ?? null,

    //         });
    //     }
    // }, [open, tender]);

    useEffect(() => {
        const getTenderStatusDetails = async () => {
            if (!open || !tender?.partiesKeyID) return;

            try {
                setLoader(true);

                setLostDocuments([]);
                setRequireErrorMessage1(false);
                setRequireErrorMessage2(false);
                setErrorMessage("");

                const response = await GetChangeTenderStatus(
                    tender.partiesKeyID
                );

                if (response?.statusCode === 0) {

                    const data = response?.responseData;

                    const selectedStatus = statusOptions.find(
                        (x) => x.value === data?.tenderStatusID
                    );

                    setFormData({
                        tenderStatusID: selectedStatus || null,
                        remark: data?.remark ?? "",
                        projectKeyID: data?.projectKeyID ?? null,
                        securityDeposit: data?.securityDeposit ?? null,
                        securityDepositAttachment:
                            data?.securityDepositAttachment ?? null,

                        performanceSecurityDeposit:
                            data?.performanceSecurityDeposit ?? null,
                        performanceSecurityDepositAttachment:
                            data?.performanceSecurityDepositAttachment ?? null,

                        bankGuarantee: data?.bankGuarantee ?? null,

                        startDate: data?.startDate ?? null,
                        endDate: data?.endDate ?? null,

                        agreementStampDuty:
                            data?.agreementStampDuty ?? null,
                        agreementAttachment:
                            data?.agreementAttachment ?? null,

                        errors: {},
                    });

                    // If API also returns lost documents
                    if (data?.tenderDocumentModel?.length > 0) {
                        setLostDocuments(data.tenderDocumentModel);
                    } else {
                        setLostDocuments([
                            {
                                documentTitle: "",
                                documentURL: "",
                            },
                        ]);
                    }
                } else {
                    setErrorMessage(
                        response?.errorMessage ||
                        "Failed to get tender status details."
                    );
                }
            } catch (error) {
                console.error("Get tender status details error:", error);
                setErrorMessage("Failed to get tender status details.");
            } finally {
                setLoader(false);
            }
        };

        getTenderStatusDetails();
    }, [open, tender?.partiesKeyID]);

    const handleLostDocumentChange = (index, field, value) => {
        setLostDocuments((prev) =>
            prev.map((doc, i) =>
                i === index
                    ? { ...doc, [field]: value }
                    : doc
            )
        );
    };

    const addLostDocument = () => {
        setLostDocuments((prev) => [
            ...prev,
            {
                documentTitle: "",
                documentURL: "",
            },
        ]);
    };

    const removeLostDocument = (index) => {
        setLostDocuments((prev) =>
            prev.filter((_, i) => i !== index)
        );
    };


    const handleSubmit = () => {
        if (
            formData.tenderStatusID === undefined ||
            formData.tenderStatusID === null ||
            formData.tenderStatusID === ""
        ) {
            setRequireErrorMessage1(true);
            return false;
        }
        if (
            formData.remark === undefined ||
            formData.remark === null ||
            formData.remark === ""
        ) {
            setRequireErrorMessage2(true);
            return false;
        }

        let payload = {};

        // 1 = In-Progress
        if (formData.tenderStatusID?.value === 1) {
            payload = {
                tenderStatusID: formData.tenderStatusID?.value,
                remark: formData.remark,
                projectKeyID: formData?.projectKeyID,
            };
        }

        // 2 = Win
        else if (formData.tenderStatusID?.value === 2) {
            payload = {
                tenderStatusID: formData?.tenderStatusID?.value,
                remark: formData?.remark,
                projectKeyID: formData?.projectKeyID,
                securityDeposit: formData?.securityDeposit,
                securityDepositAttachment: formData?.securityDepositAttachment,
                performanceSecurityDeposit: formData?.performanceSecurityDeposit,
                performanceSecurityDepositAttachment: formData?.performanceSecurityDepositAttachment,
                bankGuarantee: formData?.bankGuarantee,
                startDate: formData?.startDate,
                endDate: formData?.endDate,
                agreementStampDuty: formData?.agreementStampDuty,
                agreementAttachment: formData?.agreementAttachment,
                tenderDocumentModel: []
            };
        }

        // 3 = Lost
        else if (formData.tenderStatusID?.value === 3) {
            payload = {
                tenderStatusID: formData.tenderStatusID?.value,
                remark: formData.remark,
                tenderDocumentModel: tenderDocumentModel,
                projectKeyID: formData?.projectKeyID,
            };
        }

        onSubmit(payload);
    };


    return (
        open && (
            <>
                <div className="fixed inset-0 flex items-center justify-center z-[9999]">

                    {/* Overlay */}
                    <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>

                    {/* Dialog */}
                    {/* <div className="fixed inset-0 flex items-center justify-center z-50"> */}
                    <div className="bg-white rounded-lg shadow-lg z-10 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-h-[90vh] min-h-[60vh] flex flex-col text-sm">
                        <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
                            <h2 className="text-lg font-semibold">Update Tender Status</h2>
                            <button
                                className="text-gray-500 hover:text-gray-900"
                                onClick={onClose}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="p-6 sm:p-8 space-y-4 overflow-y-auto flex-1">

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-12">


                                <div>
                                    {/* Status */}
                                    <label className="block text-gray-700 text-12 mb-1">Status <span style={{ color: "red" }}>*</span>    </label>
                                    <Select
                                        options={statusOptions}
                                        value={formData.tenderStatusID}
                                        onChange={(option) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                tenderStatusID: option,
                                            }));
                                            setLostDocuments([]);
                                            setRequireErrorMessage1(false);
                                        }}
                                    />
                                    {requireErrorMessage1 &&
                                        (
                                            <label className="validation">{ERROR_MESSAGES}</label>
                                        )}
                                </div>

                                {/* Lost Documents */}
                                {formData.tenderStatusID?.value === 3 && (
                                    <div className="col-span-1 sm:col-span-2 mt-2">
                                        <div className="flex items-center justify-between mb-2">
                                            <label className="block text-gray-700 text-12 font-medium">
                                                Tender Lost Documents
                                            </label>

                                            <button
                                                type="button"
                                                onClick={addLostDocument}
                                                className="flex items-center gap-1 bg-[#0E4C84] hover:bg-[#0b3d6a] text-white px-3 py-1.5 rounded-md text-12 transition"
                                            >
                                                <FaPlus className="text-xs" />
                                                Add Document
                                            </button>
                                        </div>

                                        <div className="space-y-3">
                                            {tenderDocumentModel.map((doc, index) => (
                                                <div
                                                    key={index}
                                                    className="border border-gray-200 rounded-lg p-3 bg-gray-50"
                                                >
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                                                        {/* Document Title */}
                                                        <div>
                                                            <label className="block text-gray-700 text-12 mb-1">
                                                                Document Title
                                                                <span className="text-red-500 ml-1">*</span>
                                                            </label>

                                                            <input
                                                                type="text"
                                                                value={doc.documentTitle}
                                                                onChange={(e) =>
                                                                    handleLostDocumentChange(
                                                                        index,
                                                                        "documentTitle",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                placeholder="Enter document title"
                                                                className="w-full p-2 border rounded-md text-12 bg-white"
                                                            />
                                                        </div>

                                                        {/* Document Upload */}
                                                        <div>
                                                            <label className="block text-gray-700 text-12 mb-1">
                                                                Document
                                                                <span className="text-red-500 ml-1">*</span>
                                                            </label>

                                                            <div className="flex items-center gap-3">
                                                                <input
                                                                    id={`lostDocument-${index}`}
                                                                    type="file"
                                                                    accept=".jpg,.jpeg,.png,.webp,.pdf"
                                                                    className="hidden"
                                                                    onChange={async (e) => {
                                                                        const file = e.target.files?.[0];

                                                                        if (!file) return;

                                                                        const ext = file.name
                                                                            .split(".")
                                                                            .pop()
                                                                            .toLowerCase();

                                                                        const allowedExt = [
                                                                            "jpg",
                                                                            "jpeg",
                                                                            "png",
                                                                            "webp",
                                                                            "pdf",
                                                                        ];

                                                                        if (!allowedExt.includes(ext)) {
                                                                            setErrorMessage(
                                                                                "Only images and PDF files are allowed."
                                                                            );
                                                                            return;
                                                                        }

                                                                        try {
                                                                            setLoader(true);

                                                                            const response =
                                                                                await UploadImageWithNodeApi({
                                                                                    imageFile: file,
                                                                                    userId: userKeyID,
                                                                                    moduleName: "Parties",
                                                                                    projectName: "Technoland",
                                                                                });

                                                                            if (response.success) {
                                                                                handleLostDocumentChange(
                                                                                    index,
                                                                                    "documentURL",
                                                                                    response.s3Url
                                                                                );
                                                                            }
                                                                        } catch (error) {
                                                                            console.log("Upload error", error);
                                                                            setErrorMessage(
                                                                                "Failed to upload document."
                                                                            );
                                                                        } finally {
                                                                            setLoader(false);
                                                                        }
                                                                    }}
                                                                />

                                                                <label
                                                                    htmlFor={`lostDocument-${index}`}
                                                                    className="cursor-pointer bg-blue-500 hover:bg-blue-600 text-white font-medium px-3 py-2 rounded-md text-12 transition"
                                                                >
                                                                    Upload File
                                                                </label>

                                                                {doc.documentURL && (
                                                                    <a
                                                                        href={doc.documentURL}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-12"
                                                                    >
                                                                        View
                                                                        <FaEye />
                                                                    </a>
                                                                )}

                                                                {/* Remove */}
                                                                {tenderDocumentModel.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() =>
                                                                            removeLostDocument(index)
                                                                        }
                                                                        className="text-red-500 hover:text-red-700"
                                                                        title="Remove"
                                                                    >
                                                                        <FaTrash />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {formData.tenderStatusID?.value === 2 && (
                                    <>
                                        {/* Bank Guarantee region start  */}
                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Bank Guarantee
                                            </label>
                                            <div className="flex items-center space-x-4">
                                                <label className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name="bankGuarantee"
                                                        checked={formData.bankGuarantee === true}
                                                        onChange={() => setFormData({ ...formData, bankGuarantee: true })}
                                                        className="accent-blue-500"
                                                    />
                                                    <span className="text-12 text-gray-700">Yes</span>
                                                </label>
                                                <label className="flex items-center space-x-2">
                                                    <input
                                                        type="radio"
                                                        name="bankGuarantee"
                                                        checked={formData.bankGuarantee === false}
                                                        onChange={() => setFormData({ ...formData, bankGuarantee: false })}
                                                        className="accent-blue-500"
                                                    />
                                                    <span className="text-12 text-gray-700">No</span>
                                                </label>
                                            </div>
                                        </div>
                                        {formData.bankGuarantee && (
                                            <>
                                                <div>
                                                    <label className="block text-gray-700 text-12 mb-1">
                                                        Start Date
                                                    </label>
                                                    <DatePicker
                                                        minDate={minDate}
                                                        format="dd/MM/y"
                                                        dayPlaceholder="dd"
                                                        monthPlaceholder="mm"
                                                        yearPlaceholder="yyyy"
                                                        value={formData.startDate}
                                                        onChange={(selectedDate) => {
                                                            const fromDateUTC = new Date(Date.UTC(
                                                                selectedDate.getFullYear(),
                                                                selectedDate.getMonth(),
                                                                selectedDate.getDate()
                                                            ));
                                                            const fromDateISO = fromDateUTC.toISOString();
                                                            setFormData({
                                                                ...formData,
                                                                startDate: fromDateISO
                                                            });
                                                        }}
                                                        className="p-1 border rounded-md text-12"
                                                    />


                                                </div>

                                                <div className="flex-1">
                                                    <label className="block text-gray-700 text-12 mb-1">
                                                        End Date
                                                    </label>
                                                    <DatePicker
                                                        minDate={minDate}
                                                        format="dd/MM/y"
                                                        dayPlaceholder="dd"
                                                        monthPlaceholder="mm"
                                                        yearPlaceholder="yyyy"
                                                        value={formData.endDate}
                                                        onChange={(selectedDate) => {
                                                            const fromDateUTC = new Date(Date.UTC(
                                                                selectedDate.getFullYear(),
                                                                selectedDate.getMonth(),
                                                                selectedDate.getDate()
                                                            ));
                                                            const fromDateISO = fromDateUTC.toISOString();
                                                            setFormData({
                                                                ...formData,
                                                                endDate: fromDateISO
                                                            });
                                                        }}
                                                        className="p-1 border rounded-md text-12"
                                                    />

                                                </div>
                                            </>
                                        )}
                                        {/* Bank Guarantee region end  */}

                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Security Deposit
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter Security Deposit (₹)"
                                                value={formData.securityDeposit || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const regex = /^\d*(\.\d{0,2})?$/;
                                                    if (regex.test(value) && value.length <= 12) {
                                                        setFormData({
                                                            ...formData,
                                                            securityDeposit: e.target.value,
                                                        })
                                                    };
                                                }}
                                                className="w-full p-2 border rounded-md text-12"
                                            />

                                        </div>
                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Security Deposit Attachment
                                            </label>
                                            <div className="flex items-center space-x-4">

                                                <input
                                                    id="securityDepositAttachment"
                                                    type="file"
                                                    accept="
                         image/*,
                        .jpg,
                        .jpeg,
                        .png,
                        .webp,
                        .pdf,
                         application/pdf
                        "
                                                    className="hidden"
                                                    onChange={async (e) => {
                                                        let file = e.target.files[0];
                                                        if (!file) return;

                                                        const ext = file.name.split('.').pop().toLowerCase();
                                                        const allowedExt = ["jpg", "jpeg", "png", "webp", "pdf"];
                                                        if (!allowedExt.includes(ext)) {
                                                            setFormData({
                                                                ...formData,
                                                                securityDepositAttachment: "",
                                                                errors: {
                                                                    ...formData.errors,
                                                                    securityDepositAttachment: "Only images and PDF files are allowed."
                                                                }
                                                            });
                                                            return;
                                                        }

                                                        try {
                                                            setLoader(true);
                                                            const response = await UploadImageWithNodeApi({
                                                                imageFile: file,
                                                                userId: userKeyID,
                                                                moduleName: "Parties",
                                                                projectName: "Technoland",
                                                            });
                                                            if (response.success) {
                                                                setFormData({
                                                                    ...formData,
                                                                    securityDepositAttachment: response.s3Url,
                                                                    errors: { ...formData.errors, securityDepositAttachment: "" }
                                                                });
                                                            }
                                                        } catch (error) {
                                                            console.log("error", error);
                                                        } finally {
                                                            setLoader(false);
                                                        }
                                                    }}
                                                />
                                                <label
                                                    htmlFor="securityDepositAttachment"
                                                    className="cursor-pointer bg-blue-500 text-white font-medium px-3 py-2 rounded-md shadow-sm hover:bg-primary/90 active:scale-95 transition-all text:black"
                                                    style={{ margin: "0px" }}
                                                >
                                                    Upload File
                                                </label>

                                                {formData?.securityDepositAttachment && (
                                                    <div className="mb-2">

                                                        <a
                                                            href={formData?.securityDepositAttachment}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="View File"
                                                            className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                                                        >
                                                            <span>View file</span>
                                                            <FaEye className="text-xl cursor-pointer" />
                                                        </a>

                                                    </div>
                                                )}
                                            </div>
                                            {formData?.errors?.securityDepositAttachment && (
                                                <p className="text-red-500 text-11 mt-1">
                                                    {formData?.errors?.securityDepositAttachment}
                                                </p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Performance Security Deposit
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Performance Security Deposit (₹)"
                                                value={formData.performanceSecurityDeposit || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const regex = /^\d*(\.\d{0,2})?$/;

                                                    if (regex.test(value) && value.length <= 12) {
                                                        setFormData({
                                                            ...formData,
                                                            performanceSecurityDeposit: e.target.value,
                                                        })
                                                    };
                                                }}
                                                className="w-full p-2 border rounded-md text-12"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Performance Security Deposit Attachment
                                            </label>
                                            <div className="flex items-center space-x-4">

                                                <input
                                                    id="performanceSecurityDepositAttachment"
                                                    type="file"
                                                    accept="
                         image/*,
                        .jpg,
                        .jpeg,
                        .png,
                        .webp,
                        .pdf,
                         application/pdf
                        "
                                                    className="hidden"
                                                    onChange={async (e) => {
                                                        let file = e.target.files[0];
                                                        if (!file) return;

                                                        const ext = file.name.split('.').pop().toLowerCase();
                                                        const allowedExt = ["jpg", "jpeg", "png", "webp", "pdf"];
                                                        if (!allowedExt.includes(ext)) {
                                                            setFormData({
                                                                ...formData,
                                                                performanceSecurityDepositAttachment: "",
                                                                errors: {
                                                                    ...formData.errors,
                                                                    performanceSecurityDepositAttachment: "Only images and PDF files are allowed."
                                                                }
                                                            });
                                                            return;
                                                        }

                                                        try {
                                                            setLoader(true);
                                                            const response = await UploadImageWithNodeApi({
                                                                imageFile: file,
                                                                userId: userKeyID,
                                                                moduleName: "Parties",
                                                                projectName: "Technoland",
                                                            });
                                                            if (response.success) {
                                                                setFormData({
                                                                    ...formData,
                                                                    performanceSecurityDepositAttachment: response.s3Url,
                                                                    errors: { ...formData.errors, performanceSecurityDepositAttachment: "" }
                                                                });
                                                            }
                                                        } catch (error) {
                                                            console.log("error", error);
                                                        } finally {
                                                            setLoader(false);
                                                        }
                                                    }}
                                                />
                                                <label
                                                    htmlFor="performanceSecurityDepositAttachment"
                                                    className="cursor-pointer bg-blue-500 text-white font-medium px-3 py-2 rounded-md shadow-sm hover:bg-primary/90 active:scale-95 transition-all text:black"
                                                    style={{ margin: "0px" }}
                                                >
                                                    Upload File
                                                </label>
                                                {formData?.performanceSecurityDepositAttachment && (
                                                    <div className="mb-2">

                                                        <a
                                                            href={formData?.performanceSecurityDepositAttachment}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="View File"
                                                            className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                                                        >
                                                            <span>View file</span>
                                                            <FaEye className="text-xl cursor-pointer" />
                                                        </a>

                                                    </div>
                                                )}
                                            </div>
                                            {formData?.errors?.performanceSecurityDepositAttachment && (
                                                <p className="text-red-500 text-11 mt-1">
                                                    {formData?.errors?.performanceSecurityDepositAttachment}
                                                </p>
                                            )}
                                        </div>


                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Agreement Stamp Duty
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Agreement Stamp Duty (₹)"
                                                value={formData.agreementStampDuty || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const regex = /^\d*(\.\d{0,2})?$/;

                                                    if (regex.test(value) && value.length <= 12) {
                                                        setFormData({
                                                            ...formData,
                                                            agreementStampDuty: e.target.value,
                                                        })
                                                    };

                                                }}
                                                className="w-full p-2 border rounded-md text-12"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-gray-700 text-12 mb-1">
                                                Agreement Stamp Duty Attachment
                                            </label>
                                            <div className="flex items-center space-x-4">

                                                <input
                                                    id="agreementAttachment"
                                                    type="file"
                                                    accept="
                         image/*,
                        .jpg,
                        .jpeg,
                        .png,
                        .webp,
                        .pdf,
                         application/pdf
                        "
                                                    className="hidden"
                                                    onChange={async (e) => {
                                                        let file = e.target.files[0];
                                                        if (!file) return;

                                                        const ext = file.name.split('.').pop().toLowerCase();
                                                        const allowedExt = ["jpg", "jpeg", "png", "webp", "pdf"];
                                                        if (!allowedExt.includes(ext)) {
                                                            setFormData({
                                                                ...formData,
                                                                agreementAttachment: "",
                                                                errors: {
                                                                    ...formData.errors,
                                                                    agreementAttachment: "Only images and PDF files are allowed."
                                                                }
                                                            });
                                                            return;
                                                        }

                                                        try {
                                                            setLoader(true);
                                                            const response = await UploadImageWithNodeApi({
                                                                imageFile: file,
                                                                userId: userKeyID,
                                                                moduleName: "Parties",
                                                                projectName: "Technoland",
                                                            });
                                                            if (response.success) {
                                                                setFormData({
                                                                    ...formData,
                                                                    agreementAttachment: response.s3Url,
                                                                    errors: { ...formData.errors, agreementAttachment: "" }
                                                                });
                                                            }
                                                        } catch (error) {
                                                            console.log("error", error);
                                                        } finally {
                                                            setLoader(false);
                                                        }
                                                    }}
                                                />
                                                <label
                                                    htmlFor="agreementAttachment"
                                                    className="cursor-pointer bg-blue-500 text-white font-medium px-3 py-2 rounded-md shadow-sm hover:bg-primary/90 active:scale-95 transition-all text:black"
                                                    style={{ margin: "0px" }}
                                                >
                                                    Upload File
                                                </label>
                                                {formData?.agreementAttachment && (
                                                    <div className="mb-2">

                                                        <a
                                                            href={formData?.agreementAttachment}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="View File"
                                                            className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                                                        >
                                                            <span>View file</span>
                                                            <FaEye className="text-xl cursor-pointer" />
                                                        </a>

                                                    </div>
                                                )}
                                            </div>
                                            {formData?.errors?.agreementAttachment && (
                                                <p className="text-red-500 text-11 mt-1">
                                                    {formData?.errors?.agreementAttachment}
                                                </p>
                                            )}
                                        </div>
                                    </>
                                )}
                                {/* Remark */}
                                <div>
                                    <label className="block text-gray-700 text-12 mb-1">Remark <span style={{ color: "red" }}>*</span> </label>
                                    <textarea
                                        rows={3}
                                        className="w-full border p-2 rounded"
                                        value={formData.remark}
                                        onChange={(e) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                remark: e.target.value,
                                            }));

                                            setRequireErrorMessage2(false);
                                        }}
                                    />
                                    {requireErrorMessage2 &&
                                        (
                                            <label className="validation">{ERROR_MESSAGES}</label>
                                        )}
                                </div>

                                {errorMessage && (
                                    <p className="text-red-600 text-center mt-2 text-sm">{errorMessage}</p>
                                )}
                            </div>
                        </div>

                        {/* Footer Buttons */}
                        <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t flex justify-end gap-3">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded-md text-12"
                                onClick={onClose}>
                                Cancel
                            </button>
                            <button
                                className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
                                onClick={handleSubmit}
                            >
                                {formData.tenderStatusID?.value === 2 ? "Next" : "Update"}
                            </button>
                        </div>



                        <SuccessModal
                            isOpen={showSuccess}
                            onClose={() => {
                                setShowSuccess(false);
                                onClose();
                            }}
                            actionMessage="Tender Status Updated Successfully!"

                        />
                    </div>
                </div>
            </>
        )
    );
};

export default TenderStatusDialog;


